import { isTizen } from "@sunrise/utils";

import type { MemoryUsageValue } from "@/modules/memory/types";
import { readTizenMemoryStatus } from "@/modules/tizen/system.service";

export function buildMemoryUsageState(): MemoryUsageValue | null {
  return isTizen() ? readTizenMemoryStatus() : null;
}
